import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  Input,
  OnInit,
} from '@angular/core';
import { slide } from './floating-panel.component.animations';
import { ThemeColor } from '../../../types/theme';

@Component({
    selector: 'lui-floating-panel',
    templateUrl: './floating-panel.component.html',
    styleUrls: ['./floating-panel.component.scss'],
    animations: [slide],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class FloatingPanelComponent implements OnInit {
  @Input() opened!: boolean;
  @Input() color!: ThemeColor;

  isPopupVisible!: boolean;

  constructor(private readonly cdr: ChangeDetectorRef) {}

  ngOnInit(): void {
    setTimeout(() => {
      this.isPopupVisible = this.opened;
      this.cdr.markForCheck();
    }, 1000);
  }

  togglePopup(): void {
    this.isPopupVisible = !this.isPopupVisible;
  }
}
